import { updateAddPrzerwaGant } from 'actions/updateAddPrzerwaGant';
import { TechnologyContext } from 'context/TechnologyContext';
import { BetweenVerticalStart, CircleX, File, FileEdit, FileStack, X } from 'lucide-react';
import React, { useContext } from 'react';
import { useGant } from './useGant';
import { updateDeletePrzerwaGant } from 'actions/updateDeletePrzerwaGant';

const GanttContextMenu = ({ setModalGrupyOpen,contextMenu, onClose, onShowDetails, onSelectOrder,handleCenterOnStage }) => {
  const {fechparametryTechnologii} = useContext(TechnologyContext);
    const [refreshGant, refreshGantAll, refreshGantZakonczone] = useGant();
  
  if (!contextMenu) return null;



    const renderMenuProcesy = () => {
     
  
      const menuProcesy = [];

                      menuProcesy.push(
            <button
              style={{
                width: "100%",
                textAlign: "left",
                background: "transparent",
                border: "none",
                color:  '#aaaaaa' ,
                padding: "8px 12px",
                cursor: "pointer",
              }}
            // style={{ backgroundColor: resizable ? '#8abe11' : '#63636396' }}

              onMouseEnter={(e) => (e.target.style.background = "#3a3a3a")}
              onMouseLeave={(e) => (e.target.style.background = "transparent")}
              onClick={() => {
 handleCenterOnStage(contextMenu.stage, 0.25)
                onClose();
              }}
            >
              <FileStack size={20} style={{ marginRight: "15px" }} /> Zoom x 0.25
            </button>,
          );

                menuProcesy.push(
            <button
          
              style={{
                          width: "100%",
                textAlign: "left",
                background: "transparent",
                border: "none",
                color:  '#aaaaaa' ,
                padding: "8px 12px",
                cursor: "pointer",
              }}
            // style={{ backgroundColor: resizable ? '#8abe11' : '#63636396' }}

              onMouseEnter={(e) => (e.target.style.background = "#3a3a3a")}
              onMouseLeave={(e) => (e.target.style.background = "transparent")}
              onClick={() => {
 handleCenterOnStage(contextMenu.stage, 1.0)
                onClose();
              }}
            >
              <FileStack size={20} style={{ marginRight: "15px" }} /> Zoom x 1.0
            </button>,
          );


                          menuProcesy.push(
            <button
        
              style={{
                width: "100%",
                textAlign: "left",
                background: "transparent",
                border: "none",
                color:  '#aaaaaa' ,
                padding: "8px 12px",
                cursor: "pointer",
              }}
            // style={{ backgroundColor: resizable ? '#8abe11' : '#63636396' }}

              onMouseEnter={(e) => (e.target.style.background = "#3a3a3a")}
              onMouseLeave={(e) => (e.target.style.background = "transparent")}
              onClick={() => {
 handleCenterOnStage(contextMenu.stage, 2.0)
                onClose();
              }}
            >
              <FileStack size={20} style={{ marginRight: "15px" }} /> Zoom x 2.0
            </button>,
          );

          menuProcesy.push(
            <button
            disabled={contextMenu.stage.proces_nazwa_id==6}
              style={{
                width: "100%",
                textAlign: "left",
                background: "transparent",
                border: "none",
                color: contextMenu.stage.proces_nazwa_id==6 ? '#aaaaaa42' : '#aaaaaa' ,
                padding: "8px 12px",
                cursor: contextMenu.stage.proces_nazwa_id==6 ? "not-allowed" :"pointer",
              }}
            // style={{ backgroundColor: resizable ? '#8abe11' : '#63636396' }}

              onMouseEnter={(e) => (e.target.style.background = "#3a3a3a")}
              onMouseLeave={(e) => (e.target.style.background = "transparent")}
              onClick={() => {
                // onSelectOrder(contextMenu.stage);
                setModalGrupyOpen(true);
                fechparametryTechnologii(
                  contextMenu.stage.zamowienie_id,
                  contextMenu.stage.technologia_id,
                );
                onClose();
              }}
            >
              <FileStack size={20} style={{ marginRight: "15px" }} /> Arkusze
            </button>,
          );

          menuProcesy.push(
            <button
              style={{
                width: "100%",
                textAlign: "left",
                background: "transparent",
                border: "none",
                color: "#aaaaaa",
                padding: "8px 12px",
                cursor: "pointer",
              }}
              onMouseEnter={(e) => (e.target.style.background = "#3a3a3a")}
              onMouseLeave={(e) => (e.target.style.background = "transparent")}
              onClick={() => {

                      updateAddPrzerwaGant(contextMenu.stage.global_id, 480,refreshGantAll,contextMenu.stage.proces_nazwa_id);

                onClose();
              }}
            >
              <BetweenVerticalStart size={20} style={{ marginRight: "15px",marginBottom:"5px" ,color:"yellowgreen"}} /> <span style={{color:' #aaaaaa' }}> Dodaj przerwe</span>
            </button>
          );
        
  
        return menuProcesy;
      }
  

          const renderMenuPrzerwa = () => {
     
  
      const menuPrzerwa = [];


          menuPrzerwa.push(
            <button
              style={{
                width: "100%",
                textAlign: "left",
                background: "transparent",
                border: "none",
                color: "#aaaaaa",
                padding: "8px 12px",
                cursor: "pointer",
              }}
              onMouseEnter={(e) => (e.target.style.background = "#3a3a3a")}
              onMouseLeave={(e) => (e.target.style.background = "transparent")}
              onClick={() => {
                      updateAddPrzerwaGant(contextMenu.stage.global_id, 480,refreshGantAll,contextMenu.stage.proces_nazwa_id);

                onClose();
              }}
            >
                            <BetweenVerticalStart size={20} style={{ marginRight: "15px",marginBottom:"5px" ,color:"yellowgreen"}} /> <span style={{color:' #aaaaaa' }}> Dodaj przerwe</span>

            </button>
          );

                    menuPrzerwa.push(
            <button
              style={{
                width: "100%",
                textAlign: "left",
                background: "transparent",
                border: "none",
                color: "#aaaaaa",
                padding: "8px 12px",
                cursor: "pointer",
              }}
              onMouseEnter={(e) => (e.target.style.background = "#3a3a3a")}
              onMouseLeave={(e) => (e.target.style.background = "transparent")}
              onClick={() => {

                       updateDeletePrzerwaGant(contextMenu.stage.global_id,refreshGantAll,contextMenu.stage.proces_nazwa_id)
                
                // // onSelectOrder(contextMenu.stage);
                // setModalGrupyOpen(true);
                // fechparametryTechnologii(
                //   contextMenu.stage.zamowienie_id,
                //   contextMenu.stage.technologia_id,
                // );
                onClose();
              }}
            >
              <CircleX size={20} style={{ marginRight: "15px",marginBottom:"5px",color:"red" }} /> <span style={{color:' #aaaaaa' }}> Skasuj przerwe</span>
            </button>
          );
        
  
        return menuPrzerwa;
      }
      
    


  return (
    <>
      {/* Przezroczysta warstwa na cały ekran blokująca interakcję i zamykająca menu po kliknięciu gdziekolwiek */}
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          zIndex: 999,
          background: "transparent",
        }}
        onClick={onClose}
        onContextMenu={(e) => {
          e.preventDefault();
          onClose();
        }}
      />

      {/* Właściwe menu kontekstowe */}
      <div
        style={{
          position: "fixed",
          top: contextMenu.y,
          left: contextMenu.x,
          background: "#2b2b2b",
          color: "#ffffff",
          border: "1px solid #444",
          borderRadius: "6px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.4)",
          zIndex: 1000,
          padding: "6px 0",
          minWidth: "160px",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          style={{
            padding: "10px 22px",
            fontSize: "12px",
            borderBottom: "1px solid #444",
            color: "#aaa",
          }}
        >
          {contextMenu.stage.typ_grupy == 2 ? (<> {contextMenu.stage.nr}_{contextMenu.stage.rok?.substring(2, 4)} {contextMenu.stage.firma_nazwa} {contextMenu.stage.tytul} </>) : ("Przerwa" )}
        </div>
          {contextMenu.stage.typ_grupy == 2 ? renderMenuProcesy():renderMenuPrzerwa() }

      </div>
    </>
  );
};

export default GanttContextMenu;